/* eslint-disable react/jsx-props-no-spreading */
import { Toaster as Sonner, ToasterProps } from 'sonner';
import { TbIcon } from 'components/Figma';

function Toaster(props: ToasterProps) {
  return (
    <Sonner
      icons={{
        info: <TbIcon name="InformationOutlined" size="lg" className="text-denim-500" />,
        error: <TbIcon name="CrossOctagonOutlined" size="lg" className="text-coral-500" />,
        warning: <TbIcon name="WarningOutlinedTriangle" size="lg" className="text-sand-500" />,
        success: <TbIcon name="SuccessOutlined" size="lg" className="text-laurel-500" />,
      }}
      toastOptions={{
        className: '!w-[800px] !max-w-[50vw] !rounded-none !gap-4',
        classNames: {
          info: '!bg-denim-50',
          error: '!bg-coral-50',
          warning: '!bg-sand-50',
          success: '!bg-laurel-50',
          loading: '!bg-denim-50',
          closeButton: '!right-2',
        },
      }}
      {...props}
    />
  );
}

export { Toaster };
